export const taxFillingElectionList = [
  { id: 1, name: "Single" },
  { id: 3, name: "Married Filing Jointly" },
  { id: 4, name: "Married Filing Separately" },
  { id: 2, name: "Head of Household" },
  { id: 5, name: "Qualifying Widow(er)" },
];

export const statesList = [
  { name: "Alabama" },
  { name: "Alaska" },
  { name: "Arizona" },
  { name: "Arkansas" },
  { name: "California" },
  { name: "Colorado" },
  { name: "Connecticut" },
  { name: "Delaware" },
  { name: "Florida" },
  { name: "Georgia" },
  { name: "Hawaii" },
  { name: "Idaho" },
  { name: "Illinois" },
  { name: "Indiana" },
  { name: "Iowa" },
  { name: "Kansas" },
  { name: "Kentucky" },
  { name: "Louisiana" },
  { name: "Maine" },
  { name: "Maryland" },
  { name: "Massachusetts" },
  { name: "Michigan" },
  { name: "Minnesota" },
  { name: "Mississippi" },
  { name: "Missouri" },
  { name: "Montana" },
  { name: "Nebraska" },
  { name: "Nevada" },
  { name: "New Hampshire" },
  { name: "New Jersey" },
  { name: "New Mexico" },
  { name: "New York" },
  { name: "North Carolina" },
  { name: "North Dakota" },
  { name: "Ohio" },
  { name: "Oklahoma" },
  { name: "Oregon" },
  { name: "Pennsylvania" },
  { name: "Rhode Island" },
  { name: "South Carolina" },
  { name: "South Dakota" },
  { name: "Tennessee" },
  { name: "Texas" },
  { name: "Utah" },
  { name: "Vermont" },
  { name: "Virginia" },
  { name: "Washington" },
  { name: "West Virginia" },
  { name: "Wisconsin" },
  { name: "Wyoming" },
];

export const taxSpecificStatesList = [
  { name: "Alaska" },
  { name: "California" },
  { name: "Florida" },
  { name: "Illinois" },
  { name: "Nevada" },
  { name: "New Hampshire" },
  { name: "New York" },
  { name: "New York City" },
  { name: "South Dakota" },
  { name: "Tennessee" },
  { name: "Texas" },
  { name: "Wyoming" },
];
export const citiesByState = {
  Alabama: [
    "Alexander City",
    "Andalusia",
    "Anniston",
    "Athens",
    "Atmore",
    "Auburn",
    "Bessemer",
    "Birmingham",
    "Chickasaw",
    "Clanton",
    "Cullman",
    "Decatur",
    "Demopolis",
    "Dothan",
    "Enterprise",
    "Eufaula",
    "Florence",
    "Fort Payne",
    "Gadsden",
    "Greenville",
    "Guntersville",
    "Huntsville",
    "Jasper",
    "Marion",
    "Mobile",
    "Montgomery",
    "Opelika",
    "Ozark",
    "Phenix City",
    "Prichard",
    "Scottsboro",
    "Selma",
    "Sheffield",
    "Sylacauga",
    "Talladega",
    "Troy",
    "Tuscaloosa",
    "Tuscumbia",
    "Tuskegee",
  ],
  Alaska: [
    "Anchorage",
    "Cordova",
    "Fairbanks",
    "Haines",
    "Homer",
    "Juneau",
    "Ketchikan",
    "Kodiak",
    "Kotzebue",
    "Nome",
    "Palmer",
    "Seward",
    "Sitka",
    "Skagway",
    "Valdez",
  ],
  Arizona: [
    "Ajo",
    "Avondale",
    "Bisbee",
    "Casa Grande",
    "Chandler",
    "Clifton",
    "Douglas",
    "Flagstaff",
    "Florence",
    "Gila Bend",
    "Glendale",
    "Globe",
    "Kingman",
    "Lake Havasu City",
    "Mesa",
    "Nogales",
    "Oraibi",
    "Phoenix",
    "Prescott",
    "Scottsdale",
    "Sierra Vista",
    "Tempe",
    "Tombstone",
    "Tucson",
    "Walpi",
    "Window Rock",
    "Winslow",
    "Yuma",
  ],
  California: [
    "Alameda",
    "Alhambra",
    "Anaheim",
    "Antioch",
    "Arcadia",
    "Bakersfield",
    "Barstow",
    "Belmont",
    "Berkeley",
    "Beverly Hills",
    "Brea",
    "Buena Park",
    "Burbank",
    "Calexico",
    "Calistoga",
    "Carlsbad",
    "Carmel",
    "Chico",
    "Chula Vista",
    "Claremont",
    "Compton",
    "Concord",
    "Corona",
    "Costa Mesa",
    "Culver City",
    "Daly City",
    "Davis",
    "Downey",
    "El Centro",
    "El Cerrito",
    "El Monte",
    "Escondido",
    "Eureka",
    "Fairfield",
    "Fontana",
    "Fremont",
    "Fresno",
    "Fullerton",
    "Garden Grove",
    "Glendale",
    "Hayward",
    "Hollywood",
    "Huntington Beach",
    "Indio",
    "Inglewood",
    "Irvine",
    "La Habra",
    "Laguna Beach",
    "Lancaster",
    "Livermore",
    "Lodi",
    "Lompoc",
    "Long Beach",
    "Los Angeles",
    "Malibu",
    "Martinez",
    "Marysville",
    "Menlo Park",
    "Merced",
    "Modesto",
    "Monterey",
    "Mountain View",
    "Napa",
    "Needles",
    "Newport Beach",
    "Norwalk",
    "Novato",
    "Oakland",
    "Oceanside",
    "Ojai",
    "Ontario",
    "Orange",
    "Oroville",
    "Oxnard",
    "Pacific Grove",
    "Palm Springs",
    "Palmdale",
    "Palo Alto",
    "Pasadena",
    "Petaluma",
    "Pomona",
    "Port Hueneme",
    "Rancho Cucamonga",
    "Red Bluff",
    "Redding",
    "Redlands",
    "Redondo Beach",
    "Redwood City",
    "Richmond",
    "Riverside",
    "Roseville",
    "Sacramento",
    "Salinas",
    "San Bernardino",
    "San Clemente",
    "San Diego",
    "San Fernando",
    "San Francisco",
    "San Gabriel",
    "San Jose",
    "San Juan Capistrano",
    "San Leandro",
    "San Luis Obispo",
    "San Marino",
    "San Mateo",
    "San Pedro",
    "San Rafael",
    "San Simeon",
    "Santa Ana",
    "Santa Barbara",
    "Santa Clara",
    "Santa Clarita",
    "Santa Cruz",
    "Santa Monica",
    "Santa Rosa",
    "Sausalito",
    "Simi Valley",
    "Sonoma",
    "South San Francisco",
    "Stockton",
    "Sunnyvale",
    "Susanville",
    "Thousand Oaks",
    "Torrance",
    "Turlock",
    "Ukiah",
    "Vallejo",
    "Ventura",
    "Victorville",
    "Visalia",
    "Walnut Creek",
    "Watts",
    "West Covina",
    "Whittier",
    "Woodland",
    "Yorba Linda",
    "Yuba City",
  ],
  "New York": [
    "New York",
    "Buffalo",
    "Rochester",
    "Yonkers",
    "Syracuse",
    "Albany",
    "New Rochelle",
    "Mount Vernon",
    "Schenectady",
    "Utica",
    "White Plains",
    "Troy",
    "Niagara Falls",
    "Binghamton",
    "Freeport",
    "Valley Stream",
  ],
  // … etc for all other states
};

export const deductionsList = [
  { id: 1, name: "Itemized" },
  { id: 2, name: "Standard" },
];
